import { useCallback, useRef } from 'react';
import { useAuth } from '../../App';
export class ReceiptFileError extends Error {
  constructor(message: string, public status: number) { super(message); }
}
export function useReceiptFileApi() {
  const { currentShop, refreshAuth } = useAuth(); const refresh = useRef(refreshAuth); refresh.current = refreshAuth;
  const domain = currentShop?.domain;
  return useCallback(async (path: string, signal: AbortSignal, body?: unknown, binary = false) => {
    if (!domain) throw new ReceiptFileError('Choose a warehouse account first', 400);
    const request = () => fetch(`${import.meta.env.VITE_API_URL || 'https://api.whenlyapp.com'}${path}`, { credentials: 'include', cache: 'no-store', signal,
      method: body === undefined ? 'GET' : 'POST', headers: { 'X-Shop-Domain': domain, 'Content-Type': 'application/json' }, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
    let response = await request();
    if (response.status === 401) { await refresh.current(); response = await request(); }
    if (!response.ok) { const data = await response.json(); throw new ReceiptFileError(data.error || 'Unable to load or save this receipt file', response.status); }
    if (binary) {
      if (!['image/png', 'image/jpeg'].includes(response.headers.get('Content-Type') || '')) throw new Error('This is not a supported image');
      return response.blob();
    }
    return response.json();
  }, [domain]);
}
